const SESSION_KEY = 'ismobileapp';

/**
 * Detects whether the app is running inside the Stokastic native mobile app.
 *
 * Prefer the presence of `window.ReactNativeWebView`, which is injected by the
 * native WebView. For full navigations, we also rely on the `?ismobileapp=true`
 * URL param injected by the native WebView and persist that flag in
 * sessionStorage so it survives client-side React Router navigation (which
 * doesn't re-trigger the WebView URL handler).
 */
export const getIsMobileApp = (): boolean => {
  if (typeof window === 'undefined') return false;

  // Primary signal: native WebView injection.
  if ((window as any).ReactNativeWebView) {
    return true;
  }

  const fromUrl = new URLSearchParams(window.location.search).get(SESSION_KEY) === 'true';
  const fromSession = sessionStorage.getItem(SESSION_KEY) === 'true';

  // Persist the URL-derived flag only when it first appears.
  if (fromUrl && !fromSession) {
    sessionStorage.setItem(SESSION_KEY, 'true');
  }

  return fromUrl || fromSession;
};
